import ACTIONS from 'state/constants';

export const setInitialCookieConsentGroups = initialGroups => dispatch => {
  dispatch({
    type: ACTIONS.SET_INITIAL_COOKIE_CONSENT_GROUPS,
    payload: { initialGroups },
  });
};
